import { Fragment } from 'react';

import { cn } from '@repo/utils/common';

import { CONTENT_OFFSET_CLASS } from '@/shared/configs/toolbar.config';

import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ToolbarFallback } from '@/components/toolbar/ToolbarFallback';

export const RootHydrateFallback = () => {
  return (
    <Fragment>
      <ToolbarFallback />
      <div
        className={cn('flex min-h-screen flex-1 items-center justify-center', CONTENT_OFFSET_CLASS)}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <LoadingSpinner size="lg" />
        <span className="sr-only">Loading</span>
      </div>
    </Fragment>
  );
};
